import { IFilial } from 'src/utils/declarations';
import { FilialActions, FilialsActionTypes } from '../actions';

export interface State {
  filials: IFilial[];
  filialsByCity: IFilial[];
}

export const initialState: State = {
  filials: [],
  filialsByCity: [],
};

export function reducer(
  state: State = initialState,
  action: FilialActions
): State {
  switch (action.type) {
    case FilialsActionTypes.GET_FILIALS_SUCCESS: {
      return {
        ...state,
        filials: action.payload,
      };
    }
    case FilialsActionTypes.GET_FILIAL_BY_MANAGER_SUCCESS:
    case FilialsActionTypes.GET_FILIAL_BY_CITY_SUCCESS: {
      return {
        ...state,
        filialsByCity: action.payload,
      };
    }

    default: {
      return state;
    }
  }
}

export const getFilials = (state: State) => state.filials;
export const getFilialsByCity = (state: State) => state.filialsByCity;
